// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "ChatRegressionJudgeAgreement" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { ChatRegressionAgreementBucketGenShape } from "./chat-regression-agreement-bucket.gen";

export const ChatRegressionJudgeAgreementGenShape = z.strictObject({
  comparisonCount: z.number(),
  agreementCount: z.number(),
  agreementRate: z.number(),
  overturnedCount: z.number(),
  overturnRate: z.number(),
  rejectedLocatorTopCount: z.number(),
  buckets: z.array(ChatRegressionAgreementBucketGenShape),
});
